<template>
  <div v-if="isShowLoading" class="loading-overlay">
    <div class="loading-parent">
      <van-loading vertical color="#fff" size="26">
        <div :style="hcf.getTextStyle({
          color:'white',fontWeight:'bold'
        })">
          {{showLoadingText}}
        </div>
      </van-loading>
    </div>
  </div>
</template>


<script setup>
  import {onMounted, ref} from "vue";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";

  let isShowLoading = ref(false);
  let showLoadingText = ref("加载中...");
  let outTime  = 10000;
  let delayTimer =  null;
  let outTimer =  null;
  onMounted(() => {
    emitter.on("NETWORK_LOADING_VISIBLE", ({visible,delayTime=300,loadingText="加载中..."}) => {
      clearTimeout(delayTimer);
      clearTimeout(outTimer);
      if(!visible){
        isShowLoading.value = false;
      }else{
        showLoadingText.value = loadingText;
        if(delayTime <= 0){
          isShowLoading.value = true;
        }else{
          delayTimer = setTimeout(()=>{
            isShowLoading.value = true;
          },delayTime);
        }
        outTimer = setTimeout(()=>{
          isShowLoading.value = false;
        },outTime);
      }
    });
  });
</script>


<style scoped>


  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999; /* 确保在最上面 */
  }

  .loading-parent {
    padding: 13px;
    background-color: #000a;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
